<div>
  <tool-header class="tool-header" headerTitle="Financial Aid"></tool-header>

  <div class="tool-content-container main-content">
    <div class="help-page-tool-description">
      The cards below are individual tools in Financial Aid. When you click onto
      the card, you will be able to see a set of instructions on how to use each
      individual tool such as the Financial Aid Tool and Types of Financial Aid.
    </div>

    <goals-list
      class="card-container"
      [goalsList]="financialAidHelpPageList"
    ></goals-list>
  </div>
</div>
